import firebase from "firebase/app";
import "firebase/messaging";

firebase.initializeApp(process.env.FIREBASE_CONFIG);
firebase.messaging();
